import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import EventEmitter from '../../Utilities/EventEmitter'
import Fade from 'react-reveal/Fade';
import './Expired.css';
import { setDigitalData } from '../../Utilities/Utils.js';

class Expired extends Component {


    componentDidMount(){
        this.props.DGRBackgroundStore.showBlurAndHeader()
        EventEmitter.emit('event:end_point_reached');
        setDigitalData( 'mvm expired', this.props.DGRStore.club_number );
    }

    render(){
		return (
            <div className="expired">
                <Fade>
                <div className="expiredBody">
                    <div className="dgrTitleText">
                        <h2>Guest Pass Expired</h2>
                    </div>
                    <div className="dgrTitleSubText">
                        <div className="subText">
                            Please See Front Desk
                        </div>
                    </div>
                </div>
                </Fade>
            </div>
        )
    }
}


Expired = inject('DGRStore', 'DGRBackgroundStore')(observer(Expired))     
export default Expired 



// WEBPACK FOOTER //
// ./src/components/DGR/Expired/Expired.js